/* eslint-disable */
import React, { useState, useEffect } from "react";
import SideBar from "./SideBar";
import styled from "styled-components";
import { AiFillInfoCircle } from "react-icons/ai";

import { FaCheck, FaEdit, FaTrash } from "react-icons/fa";
import ExportVoucher from "./ExportVoucher";
import Swal from "sweetalert2";
import { Link, useNavigate } from "react-router-dom";
import apiInstance from "../../utils/api";
import DeleteDialog from "./features/deleteDialog";

const Top = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 10px 0;
`;

const Left = styled.div`
  font-weight: normal;
  flex: 1;
`;

const Title = styled.h5`
  font-weight: 500;
  margin-top: 10px;
  letter-spacing: 0.3px;
  color: #374151;
`;

const Div = styled.div``;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  color: #374151;
  margin-top: 20px;
`;

const Thead = styled.thead`
  background-color: #f8fafc;
  border-bottom: 2px solid #e2e8f0;
`;

const Tbody = styled.tbody`
  tr:hover {
    background-color: #f8fafc;
  }
  tr + tr {
    border-top: 1px solid #f1f5f9;
  }
`;

const Tr = styled.tr`
  text-align: left;
`;

const Th = styled.th`
  font-size: 12px;
  font-weight: 500;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 10px 14px;
  white-space: nowrap;
  text-align: left;
`;

const Td = styled.td`
  font-size: 13px;
  font-weight: 400;
  padding: 9px 14px;
  white-space: nowrap;
  vertical-align: middle;
  color: #374151;
`;

const TestVoucherList = () => {
  const nav = useNavigate();
  const [count, setCount] = useState(0);
  const [vouchers, setVouchers] = useState([]);
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [name, setName] = useState("");
  const [array, setArray] = useState([]);
  const [showToday, setShowToday] = useState(true);
  const [showFilter, setShowFilter] = useState(false);
  const [filterList, setFilterList] = useState([]);
  const [showSearch, setShowSearch] = useState(false);
  const [searchList, setSearchList] = useState([]);
  const [showOri, setShowOri] = useState(true);
  const [open, setOpen] = useState(false);
  const [id, setId] = useState("");
  const [showLoading, setShowLoading] = useState(false);
  const [totalVoucher, setTotalVoucher] = useState(0);
  const [totalCashDown, setTotalCashDown] = useState(0);
  const [totalCredit, setTotalCredit] = useState(0);
  const [totalDiscount, setTotalDiscount] = useState(0);

  const calcTotals = (list) => {
    setTotalVoucher(list.reduce((sum, v) => sum + (v.totalCharge || 0), 0));
    setTotalCashDown(list.reduce((sum, v) => sum + (v.creditAmount === 0 ? (v.netDiscount || 0) : 0), 0));
    setTotalCredit(list.reduce((sum, v) => sum + (v.creditAmount < 0 ? -(v.creditAmount || 0) : 0), 0));
    setTotalDiscount(list.reduce((sum, v) => sum + (v.discount || 0), 0));
  };

  const STORAGE_KEY = "tvl_filter_state";

  const showDialog = (id) => {
    setOpen(true);
    setId(id);
    console.log(id);
  };

  const buildExportRow = (el, test, i, j, paidBy, payWith) => {
  return {
    No: `${i + 1}.${j + 1}`,

    "Voucher Date": el.date ? el.date.split("T")[0] : "",
    "Voucher Code": el.code,

    Doctor: el?.referDoctor?.name || "",
    "Patient Name": el?.relatedPatient?.name || "",

    "Test Name": test?.name?.name || "",
    "Test Qty": test?.qty || 0,
    "Test Unit Amount": test?.unitCharge || 0,
    "Test Total Amount": test?.subCharge || 0,

    Qty: j === 0 ? el.testSelection.length : "",
    "Total Amount": j === 0 ? el.totalCharge : "",
    Discount: j === 0 ? el.discount : "",
    Net: j === 0 ? el.netDiscount : "",
    "Pay Amount": j === 0 ? el.pay : "",
    "Repay Amount": j === 0 ? el.repayAmount : "",
    Credit: j === 0 ? -el.creditAmount : "",

    // 🔥 FORCE STRING (important fix)
    "Paid By": paidBy || "-",
    "Pay With": payWith || "-",
  };
};

  useEffect(() => {
    // Restore saved filter state if the user navigated back
    const saved = sessionStorage.getItem(STORAGE_KEY);
    if (saved) {
      try {
        const s = JSON.parse(saved);
        setFrom(s.from || "");
        setTo(s.to || "");
        setFilterList(s.filterList || []);
        setShowToday(false);
        setShowFilter(true);
        setShowOri(false);
        setTotalVoucher(s.totalVoucher || 0);
        setTotalCashDown(s.totalCashDown || 0);
        setTotalCredit(s.totalCredit || 0);
        setTotalDiscount(s.totalDiscount || 0);
        return; // skip today fetch
      } catch (_) {}
    }

    const getVouchers = async () => {
      const res = await apiInstance
        .get("vouchers/today")
        .then((res) => {
          setCount(res.data.count || 0);
          setVouchers(res.data.data);
          let exportArray = [];

          res.data.data.forEach((el, i) => {
            const { paidBy, payWith } = getPaymentInfo(el);

            el.testSelection.forEach((test, j) => {
              exportArray.push(
                buildExportRow(el, test, i, j, paidBy, payWith)
              );
            });
          });

          setArray(exportArray);
          calcTotals(res.data.data);
          setShowToday(true);
          setShowFilter(false);
        })
        .catch((err) => {
          Swal.fire({
            title: "Something Wrong!",
            text: "No data for this day",
            icon: "warning",
            confirmButtonText: "CANCEL",
          });
        });
    };
    getVouchers();
  }, []);

  const getPaymentInfo = (vou) => {
    if (vou.relatedBank?.length > 0) {
      return {
        paidBy: "Bank",
        payWith: vou.relatedBank[0]?.name || "Bank",
      };
    }

    if (vou.relatedCash?.length > 0) {
      return {
        paidBy: "Cash",
        payWith: vou.relatedCash[0]?.name || "Cash",
      };
    }

    return {
      paidBy: "-",
      payWith: "-",
    };
  };

  const search = async () => {
    setShowLoading(true);
    await apiInstance
      .get("vouchers", {
        params: {
          startDate: from,
          endDate: to,
        },
      })
      .then((res) => {
        setShowLoading(false);
        const voucherData = res.data.data;
        setCount(res.data.count || 0);
        setFilterList(voucherData);

        let exportArray = [];

        voucherData.forEach((el, i) => {
          const { paidBy, payWith } = getPaymentInfo(el);

          el.testSelection.forEach((test, j) => {
            exportArray.push(
              buildExportRow(el, test, i, j, paidBy, payWith)
            );
          });
        });
        setArray(exportArray);
        calcTotals(voucherData);
        // Persist filter state for back-navigation
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
          from,
          to,
          filterList: voucherData,
          totalVoucher: voucherData.reduce((s, v) => s + (v.totalCharge || 0), 0),
          totalCashDown: voucherData.reduce((s, v) => s + (v.creditAmount === 0 ? (v.netDiscount || 0) : 0), 0),
          totalCredit: voucherData.reduce((s, v) => s + (v.creditAmount < 0 ? -(v.creditAmount || 0) : 0), 0),
          totalDiscount: voucherData.reduce((s, v) => s + (v.discount || 0), 0),
        }));
        setShowToday(false);
        setShowFilter(true);
        setShowOri(false);
      });
  };

  const SearchByName = (value) => {
    if (value) {
      setSearchList(
        filterList.filter(
          (el) =>
            el.code?.toLowerCase().includes(value.toLowerCase()) ||
            el.relatedPatient?.name
              .toLowerCase()
              .includes(value.toLowerCase()) ||
            el.referDoctor?.name.toLowerCase().includes(value.toLowerCase())
        )
      );

      // setSearchList(
      //   filterList.filter(
      //     (el) =>
      //       el.code?.toLowerCase().includes(value.toLowerCase()) ||
      //       el.relatedPatient?.name.toLowerCase().includes(value.toLowerCase()) ||
      //       el.referDoctor?.name.toLowerCase().includes(value.toLowerCase())

      //   )
      // )

      setShowSearch(true);
      setShowOri(false);
      setShowFilter(false);
      calcTotals(
        filterList.filter(
          (el) =>
            el.code?.toLowerCase().includes(value.toLowerCase()) ||
            el.relatedPatient?.name.toLowerCase().includes(value.toLowerCase()) ||
            el.referDoctor?.name.toLowerCase().includes(value.toLowerCase())
        )
      );
    } else {
      setShowSearch(false);
      setShowOri(false);
      setShowFilter(true);
      calcTotals(filterList);
    }
  };
  return (
    <div className="wrapper">
      <SideBar />
      {/* <!-- Content Wrapper. Contains page content --> */}

      <div className="content-wrapper">
        {/* <!-- Content Header (Page header) --> */}
        <div className="content-header">
          <div className="container-fluid">
            <Top>
              <Left>
                <Title>Test Voucher List</Title>
              </Left>
            </Top>
            <Div className="card">
              <Div className="card-body">
                <Top>
                  <Left>
                    <div className="row align-items-end">

                      <div className="col-md-2">
                        <label>From:</label>
                        <input
                          type="date"
                          className="form-control"
                          value={from}
                          onChange={(e) => setFrom(e.target.value)}
                        />
                      </div>

                      <div className="col-md-2">
                        <label>To:</label>
                        <input
                          type="date"
                          className="form-control"
                          value={to}
                          onChange={(e) => setTo(e.target.value)}
                        />
                      </div>

                      <div className="col-md-2">
                        <label>Doctor Name:</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Doctor..."
                          onChange={(e) => SearchByName(e.target.value)}
                        />
                      </div>

                      <div className="col-md-2">
                        <label>Patient Name:</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Patient..."
                          onChange={(e) => SearchByName(e.target.value)}
                        />
                      </div>

                      <div className="col-md-2">
                        <button
                          className="btn btn-primary w-100"
                          onClick={search}
                          disabled={showLoading}
                        >
                          {showLoading ? "Searching..." : "Search"}
                        </button>
                      </div>

                      {/* Export */}
                      <div className="col-md-2">
                        <ExportVoucher
                          excelData={array}
                          fileName={"Excel Export"}
                          totals={{ totalVoucher, totalDiscount, totalCashDown, totalCredit }}
                        />
                      </div>

                    </div>
                  </Left>
                </Top>
                <div style={{ overflowX: "auto" }}>
                    <Table>
                      <Thead>
                        <Tr>
                          <Th>#</Th>
                          <Th>Date</Th>
                          <Th>Voucher Code</Th>
                          <Th>Doctor</Th>
                          <Th>Patient Name</Th>
                          <Th>Qty</Th>
                          <Th>Total</Th>
                          <Th>Discount</Th>
                          <Th>Net</Th>
                          <Th>Pay</Th>
                          <Th>Credit</Th>
                          <Th>Paid By</Th>
                          <Th>Pay with</Th>
                          <Th>Status</Th>
                          <Th style={{ textAlign: "center" }}>Action</Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {filterList.map((vou, index) => {
                          const { paidBy, payWith } = getPaymentInfo(vou);

                          return (
                            <Tr key={vou._id}>
                              <Td>{++index}</Td>
                              <Td>{vou.date ? vou.date.split("T")[0] : "—"}</Td>
                              <Td>{vou.code}</Td>
                              <Td>{vou.referDoctor ? vou.referDoctor.name : "—"}</Td>
                              <Td>{vou.relatedPatient ? vou.relatedPatient.name : "—"}</Td>
                              <Td>{vou.testSelection?.length}</Td>
                              <Td>{vou.totalCharge}</Td>
                              <Td>{vou.discount}</Td>
                              <Td>{vou.netDiscount}</Td>
                              <Td>{vou.pay}</Td>
                              <Td>{-vou.creditAmount}</Td>
                              <Td>{paidBy}</Td>
                              <Td>{payWith}</Td>
                              <Td>
                                {vou.creditAmount !== 0 ? (
                                  <span style={{ background: "#fef3c7", color: "#92400e", fontSize: 11, padding: "3px 10px", borderRadius: 20 }}>
                                    Credit
                                  </span>
                                ) : (
                                  <span style={{ background: "#d1fae5", color: "#065f46", fontSize: 11, padding: "3px 10px", borderRadius: 20 }}>
                                    Paid
                                  </span>
                                )}
                              </Td>
                              <Td style={{ textAlign: "center" }}>
                                  <Link to={"/testslip/" + vou._id} className="btn btn-sm btn-primary">Detail <AiFillInfoCircle /></Link>
                                  &nbsp;
                                  {vou.creditAmount !== 0 ? (
                                    <Link to={"/repay/" + vou._id} className="btn btn-sm btn-primary">RePay</Link>
                                  ) : (
                                    <button type="button" className="btn btn-sm btn-secondary">Paid <FaCheck /></button>
                                  )}
                                  &nbsp;
                                  <button type="button" disabled={vou.status !== "Pending"} onClick={() => nav(`/test_sale_edit/${vou._id}`)} className="btn text-white btn-sm btn-warning"><FaEdit /></button>
                                  {" "}
                                  <button type="button" onClick={() => showDialog(vou._id)} className="btn btn-sm btn-danger"><FaTrash /></button>
                                </Td>
                            </Tr>
                          );
                        })}
                        {showSearch &&
                          searchList.map((vou, index) => {
                            const { paidBy, payWith } = getPaymentInfo(vou);
                            return(
                              <Tr key={vou._id}>
                                <Td>{++index}</Td>
                                <Td>{vou.date ? vou.date.split("T")[0] : "—"}</Td>
                                <Td>{vou.code}</Td>
                                <Td>{vou.referDoctor ? vou.referDoctor.name : "—"}</Td>
                                <Td>{vou.relatedPatient?.name}</Td>
                                <Td>{vou.testSelection?.length}</Td>
                                <Td>{vou.totalCharge}</Td>
                                <Td>{vou?.discount}</Td>
                                <Td>{vou?.netDiscount}</Td>
                                <Td>{vou?.pay}</Td>
                                <Td>{-vou?.creditAmount}</Td>
                                <Td>{paidBy}</Td>
                                <Td>{payWith}</Td>
                                <Td>
                                  {vou.creditAmount !== 0 ? (
                                    <span style={{ background: "#fef3c7", color: "#92400e", fontSize: 11, padding: "3px 10px", borderRadius: 20, fontWeight: 500 }}>Credit</span>
                                  ) : (
                                    <span style={{ background: "#d1fae5", color: "#065f46", fontSize: 11, padding: "3px 10px", borderRadius: 20, fontWeight: 500 }}>Paid</span>
                                  )}
                                </Td>
                                <Td style={{ textAlign: "center" }}>
                                  <Link to={"/testslip/" + vou._id} className="btn btn-sm btn-primary">Detail <AiFillInfoCircle /></Link>
                                  &nbsp;
                                  {vou.creditAmount !== 0 ? (
                                    <Link to={"/repay/" + vou._id} className="btn btn-sm btn-primary">RePay</Link>
                                  ) : (
                                    <button type="button" className="btn btn-sm btn-secondary">Paid <FaCheck /></button>
                                  )}
                                  &nbsp;
                                  <button type="button" disabled={vou.status !== "Pending"} onClick={() => nav(`/test_sale_edit/${vou._id}`)} className="btn text-white btn-sm btn-warning"><FaEdit /></button>
                                  {" "}
                                  <button type="button" onClick={() => showDialog(vou._id)} className="btn btn-sm btn-danger"><FaTrash /></button>
                                </Td>
                              </Tr>
                            );
                        })}
                        {showOri &&
                          vouchers.map((vou, index) => {
                            const { paidBy, payWith } = getPaymentInfo(vou);
                            return(
                              <Tr key={vou._id}>
                                <Td>{++index}</Td>
                                <Td>{vou?.date ? vou.date.split("T")[0] : "—"}</Td>
                                <Td>{vou?.code}</Td>
                                <Td>{vou?.referDoctor ? vou.referDoctor.name : "—"}</Td>
                                <Td>{vou?.relatedPatient?.name}</Td>
                                <Td>{vou?.testSelection?.length}</Td>
                                <Td>{vou?.totalCharge}</Td>
                                <Td>{vou?.discount}</Td>
                                <Td>{vou?.netDiscount}</Td>
                                <Td>{vou?.pay}</Td>
                                <Td>{-vou?.creditAmount}</Td>
                                <Td>{paidBy}</Td>
                                <Td>{payWith}</Td>
                                <Td>
                                  {vou.creditAmount !== 0 ? (
                                    <span style={{ background: "#fef3c7", color: "#92400e", fontSize: 11, padding: "3px 10px", borderRadius: 20, fontWeight: 500 }}>Credit</span>
                                  ) : (
                                    <span style={{ background: "#d1fae5", color: "#065f46", fontSize: 11, padding: "3px 10px", borderRadius: 20, fontWeight: 500 }}>Paid</span>
                                  )}
                                </Td>
                                <Td style={{ textAlign: "center" }}>
                                  <Link to={"/testslip/" + vou._id} className="btn btn-sm btn-primary">Detail <AiFillInfoCircle /></Link>
                                  &nbsp;
                                  {vou.creditAmount !== 0 ? (
                                    <Link to={"/repay/" + vou._id} className="btn btn-sm btn-primary">RePay</Link>
                                  ) : (
                                    <button type="button" className="btn btn-sm btn-secondary">Paid <FaCheck /></button>
                                  )}
                                  &nbsp;
                                  <button type="button" disabled={vou.status !== "Pending"} onClick={() => nav(`/test_sale_edit/${vou._id}`)} className="btn text-white btn-sm btn-warning"><FaEdit /></button>
                                  {" "}
                                  <button type="button" onClick={() => showDialog(vou._id)} className="btn btn-sm btn-danger"><FaTrash /></button>
                                </Td>
                              </Tr>
                            );
                          })}
                      </Tbody>
                    </Table>
                  </div>
                  

                    <div className="row" style={{ marginTop: 16, paddingTop: 12, borderTop: "1px solid #e2e8f0" }}>
                      <div className="col-md-8">
                        <div className="row">
                          <div className="col-3">
                            <label style={{ fontSize: 11, color: "#6b7280", textTransform: "uppercase", letterSpacing: "0.5px", display: "block", marginBottom: 2 }}>Total Amount</label>
                            <span style={{ fontSize: 15, color: "#374151" }}>{totalVoucher.toLocaleString()}</span>
                          </div>
                          <div className="col-3">
                            <label style={{ fontSize: 11, color: "#6b7280", textTransform: "uppercase", letterSpacing: "0.5px", display: "block", marginBottom: 2 }}>Total Discount</label>
                            <span style={{ fontSize: 15, color: "#374151" }}>{totalDiscount.toLocaleString()}</span>
                          </div>
                          <div className="col-3">
                            <label style={{ fontSize: 11, color: "#6b7280", textTransform: "uppercase", letterSpacing: "0.5px", display: "block", marginBottom: 2 }}>Total Cash Down</label>
                            <span style={{ fontSize: 15, color: "#065f46" }}>{totalCashDown.toLocaleString()}</span>
                          </div>
                          <div className="col-3">
                            <label style={{ fontSize: 11, color: "#6b7280", textTransform: "uppercase", letterSpacing: "0.5px", display: "block", marginBottom: 2 }}>Total Credit</label>
                            <span style={{ fontSize: 15, color: "#92400e" }}>{totalCredit.toLocaleString()}</span>
                          </div>
                        </div>
                      </div>
                    </div>
              </Div>
            </Div>
          </div>
          <DeleteDialog
            open={open}
            close={() => setOpen(false)}
            id={id}
            setOpen={setOpen}
            setFilterList={setFilterList}
            filterList={filterList}
          />
        </div>
      </div>
    </div>
  );
};

export default TestVoucherList;
